<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>
            <div>Upload new file</div>
            <br>
            <div>
                <input
                    type="file"
                    @change="onFileSelected"
                    ref="fileInput"
                >
            </div>
            <br>
            <div>
                <label style="font-size: 13px">Enter file tag (to be used in link). Otherwise file's name will be used<br>Link example: <i>https://air.vote/files/sanitation_offer</i><br>Where
                    <i>sanitation_offer</i> is file tag.</label>
                <b-form-input id="place_id" type="text" v-model="tagValue"
                              placeholder="file tag (for link)"></b-form-input>
            </div>
            <br>
            <input type="checkbox" name="createShortLink" :value="createShortLink" v-model="createShortLink"> Create super-short link

            <div class="upload_result" v-if="result.show">
                <div>Response:</div>
                <div class="response_input_block">
                    <md-field class="response_input_md">
                        <label>Full url</label>
                        <md-input v-model="result.full_url" id="result_full_url"></md-input>
                    </md-field>
                    <button @click="onInputCopyClick('result_full_url')">Copy</button>
                </div>
                <div class="response_input_block" v-if="result.short_url">
                    <md-field class="response_input_md">
                        <label>Short url</label>
                        <md-input v-model="result.short_url" id="result_short_url"></md-input>
                    </md-field>
                    <button @click="onInputCopyClick('result_short_url')">Copy</button>
                </div>
                <div class="response_input_block">
                    <md-field class="response_input_md">
                        <label>Tag</label>
                        <md-input v-model="result.tag" id="result_tag"></md-input>
                    </md-field>
                    <button @click="onInputCopyClick('result_tag')">Copy</button>
                </div>
            </div>

            <template v-slot:modal-footer>
                <div class="footerButton__wrapper">
                    <a v-if="!settings.hideOkButton" class="onOk__btn" @click="upload">
                        <div>
                            <b-spinner v-if="uploadSpinner" small></b-spinner>
                            <span v-else>Upload</span>
                        </div>
                    </a>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import _ from "lodash";
import errorMixin from '@/mixins/errorMixin';
import {mapActions} from "vuex";

export default {
    name: 'customModalPopap',

    mixins: [errorMixin],

    data() {
        return {
            showInfoModal: !_.isEmpty(this.settings),
            uploadSpinner: false,
            createShortLink: false,
            tagValue: null,
            result: {
                show: false,
                tag: '',
                full_url: '',
                short_url: '',
                guid: ''
            }
        }
    },

    watch: {
        settings(newValue) {
            this.showInfoModal = !_.isEmpty(newValue)
        }
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {
                    windowWidth: null,
                }
            }
        },
    },

    methods: {

        ...mapActions({
            uploadLandingFile: 'question/uploadLandingFile',
        }),


        async onClose() {
            this.showInfoModal = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },

        async onFileSelected(e) {
            this.selectedFile = e.target.files || e.dataTransfer.files;
        },

        async upload(e) {
            if (!this.selectedFile || !this.selectedFile[0]) {
                this.showErrorModal('please choose a file')
                return
            }
            this.resetResult()
            this.uploadSpinner = true
            try {
                const response = await this.uploadLandingFile({
                    createShortLink: this.createShortLink,
                    tag: this.tagValue,
                    file: this.selectedFile[0],
                });
                response.show = true
                this.result = response
                // this.showInfoModal = false
            } catch (e) {
                console.log('error', e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.uploadSpinner = false
            }
        },
        onInputCopyClick(id) {
            const field = document.getElementById(id)
            field.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                this.setMessageModel({
                    msg: 'Failed to copy. Please use CTRL+C to copy',
                    duration: 1000
                })
            } finally {

            }
        },

        resetResult() {
            this.result = {
                show: false,
                tag: '',
                full_url: '',
                short_url: '',
                guid: ''
            }
        },

    },
}
</script>

<style scoped>

.upload_result {
    border: 1px solid black;
    margin-top: 16px;
    padding: 8px;
}

.response_input_block button {
    height: 35px;
    margin-left: 12px;
}

.response_input_block {
    display: flex;
    align-items: center;
}

.response_input_md {
    margin-top: 0px;
}
</style>